export default __webpack_public_path__ + "static/media/hekma.0d18d1d0.png";